/** Display title for referral cards and detail headers (street + city/state when available). */
export function formatReferralDisplayAddress(referral) {
  if (!referral) return 'Referral Agreement';

  const street = (referral.property_address || '').trim();
  const city = (referral.property_address_city || '').trim();
  const state = (referral.property_address_state || '').trim();
  const cityState = [city, state].filter(Boolean).join(', ');

  if (street && cityState) return `${street}, ${cityState}`;
  if (street) return street;
  if (cityState) return cityState;
  return 'Referral Agreement';
}
